export default __webpack_public_path__ + "static/media/ring.92cfc542.png";